import { flow } from 'lodash';
import { processEmoticon } from './emoticon-processor';
import { processAt } from './at-processor';
import { createPlainText } from './utils';

export const PROCESSORS = {
    EMOJI: processEmoticon,
    AT: processAt,
};

// eslint-disable-next-line
// @ts-ignore
export function transformContentAST(str, processors) {
    const processor = flow(processors);
    const initialAST = [createPlainText(str)];

    return processor(initialAST);
}
